import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const TarifPnbp = () => {
    const columns = [
        {
            name: 'ID Tarif PNBP',
            cell: row => row['idTarifPnbp'] 
        },
        {
            name: 'Jenis Pemeriksaan',
            cell: row => row['jnPemeriksaan'] 
        },
        {
            name: 'Satuan',
            cell: row => row['satuan'] 
        },
        {
            name: 'Tarif',
            cell: row => row['tarif'] 
        },
        {
            name: 'Kelompok Pemeriksaan',
            cell: row => row['kelPemeriksaan'] 
        }
    ];

    const masterService = useMemo(() => new MasterService(), []);

    const [allTarifPnbp, setAllTarifPnbp] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await masterService.listTarifPnbp(null, 0, 1000); // ambil semua data
                setAllTarifPnbp(response.data.data);
            } catch (error) {
                console.error(error);
                setAllTarifPnbp([]);
            }
            setLoading(false);
        };

        fetchData();
    }, [masterService]);

    // Data hasil filter pencarian
    const filteredData = useMemo(() => {
        if (!search) return allTarifPnbp;
        return allTarifPnbp.filter(item =>
            item.jnPemeriksaan?.toLowerCase().includes(search.toLowerCase())
        );
    }, [allTarifPnbp, search]);

    // Data per halaman
    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * perPage;
        const end = start + perPage;
        return filteredData.slice(start, end);
    }, [filteredData, currentPage, perPage]);

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Form>
                                <Row className="align-items-end">
                                    <Col sm="3">
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Cari Jenis Pemeriksaan"
                                                value={search}
                                                onChange={(e) => {
                                                    setSearch(e.target.value);
                                                    setCurrentPage(1); // reset halaman saat pencarian berubah
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Tarif PNBP</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {loading && <Spinner />}
                                {!loading && (
                                    <DataTable
                                        customStyles={{
                                            headCells: {
                                                style: {
                                                    backgroundColor: '#00acee',
                                                    color: 'white'
                                                }
                                            }
                                        }}
                                        columns={columns}
                                        data={paginatedData}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationTotalRows={filteredData.length}
                                        onChangePage={(page) => setCurrentPage(page)}
                                        onChangeRowsPerPage={(newPerPage, page) => {
                                            setPerPage(newPerPage);
                                            setCurrentPage(page);
                                        }}
                                    />
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default TarifPnbp;
